import StatusDiod from "@/components/StatusDiod/StatusDiod";
import { FC } from "react";
import { IStatusBar } from "./StatusBar.props";
import { mapCallStatus } from "../CallingLineList.const";
import { useTranslate } from "@/hooks";
import styles from "./StatusBar.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { Fade, Tooltip } from "@mui/material";
import { colorPrimary } from "@/constants/colors";

const StatusBar: FC<IStatusBar> = ({ statuses, parentWidth }) => {
	const translate = useTranslate(); // hook для перевода текста

	return parentWidth && parentWidth > 290 ? (
		<div className={styles.statuses}>
			{Object.entries(statuses).map(([status, counter], idx) =>
				status !== "UNKNOWN" ? (
					<div key={idx} className={styles.statusContainer}>
						<StatusDiod
							position="relative"
							color={mapCallStatus({ status: status as "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" }).color}
							text={translate(mapCallStatus({ status: status as "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" }).titleStatus)}
							pulsing={false}
							diodParams={{ top: 0, left: 0 }}
							className={styles.statusDiodContainer}
						/>
						<div>{counter}</div>
					</div>
				) : (
					<></>
				)
			)}
		</div>
	) : (
		<Tooltip
			TransitionComponent={Fade}
			TransitionProps={{ timeout: 0 }}
			title={
				<div className={styles.statuses}>
					{Object.entries(statuses).map(([status, counter], idx) =>
						status !== "UNKNOWN" ? (
							<div key={idx} className={styles.statusContainer}>
								<StatusDiod
									position="relative"
									color={mapCallStatus({ status: status as "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" }).color}
									text={translate(mapCallStatus({ status: status as "PENDING" | "IN_PROGRESS" | "COMPLETED" | "FAILED" }).titleStatus)}
									pulsing={false}
									diodParams={{ top: 0, left: 0 }}
									className={styles.statusDiodContainer}
								/>
								<div>{counter}</div>
							</div>
						) : (
							<></>
						)
					)}
				</div>
			}
			placement={"top"}
			arrow
			slotProps={{
				tooltip: {
					onClick: (e: any) => e.stopPropagation(),
					onMouseDown: (e: any) => e.stopPropagation(),
					sx: {
						background: "#F8FAFF",
						color: "#918c8c",
						padding: "8px 8px",
						borderRadius: "6px",
						border: "1px solid #D9E2F0",
						fontSize: "11px",
						lineHeight: 1.35,
						maxWidth: "260px",
						boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
						whiteSpace: "normal",
						textAlign: "center",
					},
				},
				arrow: {
					sx: {
						color: "#F8FAFF", // цвет самого треугольника
						"&:before": {
							border: "1px solid #D9E2F0", // рамка вокруг стрелки
						},
					},
				},
			}}
		>
			<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faChartColumn} size="xl" color={colorPrimary} />
		</Tooltip>
	);
};

export default StatusBar;
